
export enum BusinessPrivacyMode {
  Public = 'Public',
  Hybrid = 'Hybrid',
  Hidden = 'Hidden',
  Internal = 'Internal'
}

export function allowsPublicListing(privacyMode: BusinessPrivacyMode): boolean {
  return privacyMode == BusinessPrivacyMode.Public || privacyMode == BusinessPrivacyMode.Hybrid;
}

export function allowsPublicCalendar(privacyMode: BusinessPrivacyMode): boolean {
  return privacyMode == BusinessPrivacyMode.Public || privacyMode == BusinessPrivacyMode.Internal;
}

export function allowsBookingWithoutInvite(privacyMode: BusinessPrivacyMode) : boolean {
  return privacyMode == BusinessPrivacyMode.Public || privacyMode == BusinessPrivacyMode.Internal;
}
